import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <header className="site-header" data-testid="site-header">
        <Link to="/" className="brand" data-testid="nav-logo">
          <img src="/assets/brand/logo.png" alt="KR Studio" />
        </Link>
        <nav className="nav-desktop" aria-label="Primary">
          <ul className="nav-links">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <Link to={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="nav-right">
          <Link to="/contact" className="btn btn-primary btn-sm" data-testid="nav-cta-start-project">
            Start a project <ArrowUpRight size={15} strokeWidth={2.5} />
          </Link>
          <button
            className="nav-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            data-testid="nav-hamburger"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>

      <div className={`mobile-nav ${open ? "open" : ""}`} data-testid="mobile-nav-overlay" aria-hidden={!open}>
        <div className="mobile-nav-top">
          <img src="/assets/brand/logo.png" alt="KR Studio" className="mobile-logo" />
          <button className="mobile-close" aria-label="Close menu" onClick={() => setOpen(false)} data-testid="mobile-nav-close">
            <X size={26} />
          </button>
        </div>
        <ul>
          {NAV_LINKS.map((l, i) => (
            <li key={l.href} style={{ transitionDelay: open ? `${80 + i * 50}ms` : "0ms" }}>
              <Link to={l.href} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                {l.label}
              </Link>
            </li>
          ))}
          <li style={{ transitionDelay: open ? `${80 + NAV_LINKS.length * 50}ms` : "0ms" }}>
            <Link to="/contact" className="mobile-cta" onClick={() => setOpen(false)} data-testid="mobile-nav-link-contact">
              Contact <ArrowUpRight size={20} />
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};
